"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderCellViews = useRenderCellViews;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
var constants_1 = require("../../../../../constants/constants");
var TYPE_LABELS = (_a = {},
    _a[constants_1.RewardTrackTypes.TIER_PROGRESSION] = "Tier Progression",
    _a[constants_1.RewardTrackTypes.LEVEL_PROGRESSION] = "Level Progression",
    _a);
function useRenderCellViews() {
    // the shared table passes the value of the current cell, not the whole record, so each entry reads cellValue
    var renderCellViews = (0, react_2.useCallback)(function (cellValue) {
        var typeLabel = TYPE_LABELS[cellValue];
        var milestones = (Array.isArray(cellValue) ? cellValue : []);
        return [
            { key: "name", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm font-medium text-foreground", children: cellValue }) },
            {
                key: "reward_track_type",
                content: typeLabel ? ((0, jsx_runtime_1.jsx)(react_1.Chip, { className: "text-nowrap text-xs", color: "default", size: "sm", variant: "soft", children: typeLabel })) : ((0, jsx_runtime_1.jsx)("span", { className: "text-sm text-muted", children: "General" })),
            },
            { key: "source", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm text-muted", children: cellValue }) },
            { key: "target", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm text-muted", children: cellValue }) },
            { key: "milestones", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm text-muted", children: milestones.length }) },
        ];
    }, []);
    return { renderCellViews: renderCellViews };
}
